import { useQuotesManagerContext } from '../context/quotes-manager.js';
export const useQuotesManager = () => {
    const context = useQuotesManagerContext();
    if (!context.value) {
        throw new Error('useQuotesManager must be used within a QuoteManagerProvider');
    }
    return context.value;
};
